import { Input } from 'reactstrap';
import styled from 'styled-components';

interface InputProps {
  hasErrors?: boolean;
}

export const InputStyled = styled(Input)<InputProps>`
  border: ${props =>
    props.hasErrors ? '1px solid red' : '1px solid lightgrey'};
  width: 100%;
  height: 38px;
  border-radius: 4px;
  padding: 12px;
  font-family: inherit;
`;

export const GenericInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
